/**
 * Plain text from composer doc (paragraphs → newline-separated).
 */
export function getComposerPlainText(editor) {
  if (!editor) return ''
  const lines = []
  editor.state.doc.forEach((block) => {
    if (block.type.name !== 'paragraph') return
    let line = ''
    block.forEach((child) => {
      if (child.type.name === 'text') line += child.text
      else if (child.type.name === 'hardBreak') line += '\n'
    })
    lines.push(line)
  })
  return lines.join('\n')
}
